import { ComboBox, DefaultButton, DialogFooter, Icon, IconButton, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, PrimaryButton, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, Toggle, TooltipHost, ValidationState } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { dismissMessage, getAccountTypes, getCurrencies, getLimitations, reset, resetCurrencies, resetLimitations, resetAccountTypes, setIsFilteredAccountTypesSet, setIsFilteredCurrenciesSet, setSelectedAccountTypeItems, setSelectedCurrencyItems, setIsFilteredLimitationsSet, setSelectedLimitationItems, resetItem, updateOpenAccountDefaultConfiguration, setSelectedRole, setSelectedUserType, resetRoles, setIsFilteredRolesSet, getRoles, resetUserTypes, setIsFilteredUserTypesSet, getUserTypes, updateClientConfiguration, setSelectedGroupItem, resetGroups, setIsFilteredGroupsSet, getGroups } from "./OrganizationClientPortalSettingFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, InputField, NumberInputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../repository/Accountant/common_pb";
import { TableState } from "../../../common/Table/TableSate";
import { AccountStatus, LimitationType, Operations } from "../../../../app/Enums";
import { UpdateClientConfigurationRequest, ClientConfigurationResponse, UpdateClientConfigurationResponse } from "../../../../repository/UserManagement/organizationclientportalsetting_pb";
import { List } from "../../../common/List/List";
import { Popup } from "../../../common/Popup/Popup";
import { UsersPage } from "../../../pages/Customers/Users/UsersPage";
import { LimitationsPage } from "../../../pages/Accountant/Limitations/LimitationsPage";
import { AccountTypesPage } from "../../../pages/Accountant/AccountTypes/AccountTypesPage";
import { CurrenciesPage } from "../../../pages/Accountant/Currencies/CurrenciesPage";
import { GetUserTypesRequest } from "../../../../repository/UserManagement/Customers/usertype_pb";
import { GetRolesRequest } from "../../../../repository/UserManagement/Customers/role_pb";
import { RolesPage } from "../../../pages/Customers/Roles/RolesPage";
import { UserTypesPage } from "../../../pages/Customers/UserTypes/UserTypesPage";
import { GetGroupsRequest } from "../../../../repository/UserManagement/Customers/group_pb";
import { GroupsPage } from "../../../pages/Customers/Groups/GroupsPage";

let req: UpdateClientConfigurationRequest;
let roleReq: GetRolesRequest;
let userTypeReq: GetUserTypesRequest;
let groupsReq: GetGroupsRequest;

let promise: any;
let getFilterPromise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;

export const OrganizationClientPortalSettingForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();
    const [currentAction, setCurrenctAction] = useState(0)


    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any, groups: TableState, roles: TableState, userTypes: TableState } = useAppSelector((state) => {

        return {
            isLoading: state.organizationClientPortalSettingForm.isLoading, message: state.organizationClientPortalSettingForm.message, stage1: state.organizationClientPortalSettingForm.stage1,
            userTypes: state.organizationClientPortalSettingForm.userTypes,
            roles: state.organizationClientPortalSettingForm.roles,
            groups: state.organizationClientPortalSettingForm.groups,

        }
    })

    useEffect(() => {
        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }

        var l = searchParams.get('org');
        req = new UpdateClientConfigurationRequest();
        roleReq = new GetRolesRequest();
        userTypeReq = new GetUserTypesRequest();
        groupsReq = new GetGroupsRequest();

        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
                req.setId(Number(current.organization?.id))

            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setId(org)
                userTypeReq.setOrganization(wrapper)
                roleReq.setOrganization(wrapper)
                groupsReq.setOrganization(wrapper)

            }
        } else {
            req.setId(Number(current.organization?.id))
        }


        const boolv = new BoolValue();
        boolv.setValue(true);
        roleReq.setNumofresults(state.roles.numberOfResults)
        roleReq.setOrder(state.roles.isDescending)
        userTypeReq.setNumofresults(state.userTypes.numberOfResults)
        userTypeReq.setOrder(state.userTypes.isDescending)
        groupsReq.setNumofresults(state.groups.numberOfResults)
        groupsReq.setOrder(state.groups.isDescending)

        if (props.renderObject?.roleId)
            dispatch(setSelectedRole(([{ id: props.renderObject.roleId, name: props.renderObject.roleName }])))

        if (props.renderObject?.userTypeId)
            dispatch(setSelectedUserType(([{ id: props.renderObject.userTypeId, name: props.renderObject.userTypeName }])))

        if (props.renderObject?.groupId)
            dispatch(setSelectedGroupItem(([{ id: props.renderObject.groupId, name: props.renderObject.groupName }])))



        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])

    const onRoleFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetRoles())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        roleReq.setSearch(wrapper)
        roleReq.setNextto(0)
        dispatch(setIsFilteredRolesSet(false))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))

        return [];

    }
    const onUserTypeFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {
        dispatch(resetUserTypes())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        userTypeReq.setSearch(wrapper)
        userTypeReq.setNextto(0)
        dispatch(setIsFilteredUserTypesSet(false))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))

        return [];
    }
    const onGroupFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {
        dispatch(resetGroups())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        groupsReq.setSearch(wrapper)
        groupsReq.setNextto(0)
        dispatch(setIsFilteredGroupsSet(false))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getGroups({ body: groupsReq, headers: getHeaders() }))

        return [];
    }
    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("subscriptions")} onDismiss={() => { setCurrenctAction(0) }} >

                <RolesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedRole([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 101)} title={t("clientTypes")} onDismiss={() => { setCurrenctAction(0) }} >

                <UserTypesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedUserType([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 102)} title={t("groups")} onDismiss={() => { setCurrenctAction(0) }} >

                <GroupsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedGroupItem([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>




            <Formik
                enableReinitialize={true}
                initialValues={{
                    role: undefined,
                    userType: undefined,
                    group: undefined,
                    typeName: props?.renderObject?.name ?? "",
                    isIdentityVerificationRequired: props?.renderObject?.isIdentityVerificationRequired ?? false,
                    identityVerificationDocuments: (props.renderObject?.identityVerificationDocuments) ? props.renderObject.identityVerificationDocuments as DynamicField[] : [] as DynamicField[],
                    canOpenAccount: props?.renderObject?.canOpenAccount ?? false,
                    isAccountLockingEnabledByDefault: props?.renderObject?.isAccountLockedByDefault ?? false,
                    isDefault: props?.renderObject?.isDefault ?? false

                }}

                validationSchema={Yup.object({
                    typeName: inputs.userTypeName,
                })}

                onSubmit={(values, actions) => {


                    let role = state.roles.selected.at(0);
                    let userType = state.userTypes.selected.at(0);
                    let group = state.groups.selected.at(0);

                    if (group) {
                        var r = new Int32Value()
                        r.setValue(group?.id)
                        req.setGroup(r)
                    }
                    req.setRole(role?.id);
                    req.setUsertype(userType?.id);
                    req.setTypename(values.typeName?.trim())
                    req.setIsidentityverificationrequired(values.isIdentityVerificationRequired)
                    req.setIsaccountlockedbydefault(values.isAccountLockingEnabledByDefault)
                    req.setCanopenaccount(values.canOpenAccount)
                    req.setIsdefault(values.isDefault)

                    const extraField: ExtraField[] = [];
                    const count: Number = 1;
                    values.identityVerificationDocuments.forEach((e: DynamicField) => {
                        const r = new ExtraField();
                        r.setKey(e.key);
                        r.setLabel(e.label?.trim() ?? "")
                        r.setType(1)
                        r.setValue(e.value.trim())
                        extraField.push(r)
                    })
                    req.setIdentityverificationdocumentsList(extraField)



                    promise = dispatch(updateClientConfiguration({ body: req, headers: getHeaders() }))
                    promise.unwrap()
                        .then((res: UpdateClientConfigurationResponse.AsObject) => {
                            if (res) {
                                if (props?.onSuccess) {
                                    props?.onSuccess({
                                        roleId: role?.id,
                                        roleName: role?.name,
                                        userTypeId: userType?.id,
                                        userTypeName: userType?.name,
                                        canOpenAccount: values?.canOpenAccount,
                                        name: values?.typeName?.trim(),
                                        isAccountLockedByDefault: values?.isAccountLockingEnabledByDefault,
                                        isIdentityVerificationRequired: values?.isIdentityVerificationRequired,
                                        identityVerificationDocuments: values.identityVerificationDocuments,
                                        isDefault: values.isDefault,

                                        groupId: group?.id,
                                        groupName: group?.name

                                    });
                                }
                            }
                            actions.setSubmitting(false)


                        })
                        .catch((error: ApiMessage) => {
                            actions.setSubmitting(false)
                        })

                }}

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }


                            {props.type == FormType.ADD ? <Stack>
                                <Label required
                                    disabled={state.isLoading}>{t("clientType")}</Label>
                                <List
                                    inputProps={{ placeholder: t("clientType"), required: true }}
                                    disabled={state.isLoading}
                                    suggestionsHeaderText={t('clientTypes')}
                                    isLoading={state.userTypes.items.length == 0 ? state.userTypes.isFetching : false}
                                    isSearching={state.userTypes.items.length > 0 ? state.userTypes.isFetching : false}
                                    moreSuggestionsAvailable={state.userTypes.hasMore && !state.userTypes.isFetching}
                                    suggestions={state.userTypes.items.length > 0 ? state.userTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.userTypes.items.length > 0 && !state.userTypes.isFetching) {
                                            userTypeReq.setNextto(state.userTypes.items.at(state.userTypes.items.length - 1).id)
                                            getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.userTypes.items.findIndex(e => e.id == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedUserType([state.userTypes.items.at(u)]))
                                            if (formkikProps.values.typeName == undefined || formkikProps.values.typeName?.trim()?.length == 0) {
                                                formkikProps.setFieldValue("typeName", state.userTypes.items.at(u)?.name);
                                            }
                                        }
                                    }}
                                    isPeoplePicker={false}
                                    selectedItems={state.userTypes.selected.length > 0 ? state.userTypes.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedUserType([]))

                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetUserTypes())
                                        userTypeReq.setNextto(0)
                                        dispatch(setIsFilteredUserTypesSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onUserTypeFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(101)

                                            }
                                        }]}
                                />

                            </Stack> : undefined}

                            <Stack>
                                <Label required
                                    disabled={state.isLoading}>{t("subscription")}</Label>
                                <List
                                    inputProps={{ placeholder: t("subscription"), required: true }}
                                    disabled={state.isLoading}
                                    suggestionsHeaderText={t('subscriptions')}
                                    isLoading={state.roles.items.length == 0 ? state.roles.isFetching : false}
                                    isSearching={state.roles.items.length > 0 ? state.roles.isFetching : false}
                                    moreSuggestionsAvailable={state.roles.hasMore && !state.roles.isFetching}
                                    suggestions={state.roles.items.length > 0 ? state.roles.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.roles.items.length > 0 && !state.roles.isFetching) {
                                            roleReq.setNextto(state.roles.items.at(state.roles.items.length - 1).id)
                                            getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.roles.items.findIndex(e => e.id == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedRole([state.roles.items.at(u)]))
                                        }
                                    }}
                                    isPeoplePicker={false}
                                    selectedItems={state.roles.selected.length > 0 ? state.roles.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedRole([]))

                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetRoles())
                                        roleReq.setNextto(0)
                                        dispatch(setIsFilteredRolesSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onRoleFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(100)

                                            }
                                        }]}
                                />

                            </Stack>



                            <Stack>
                                <Label
                                    disabled={state.isLoading}>{t("group")}</Label>
                                <List
                                    inputProps={{ placeholder: t("group"),  }}
                                    disabled={state.isLoading}
                                    suggestionsHeaderText={t('groups')}
                                    isLoading={state.groups.items.length == 0 ? state.groups.isFetching : false}
                                    isSearching={state.groups.items.length > 0 ? state.groups.isFetching : false}
                                    moreSuggestionsAvailable={state.groups.hasMore && !state.groups.isFetching}
                                    suggestions={state.groups.items.length > 0 ? state.groups.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.groups.items.length > 0 && !state.groups.isFetching) {
                                            groupsReq.setNextto(state.groups.items.at(state.groups.items.length - 1).id)
                                            getFilterPromise = dispatch(getGroups({ body: groupsReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.groups.items.findIndex(e => e.id == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedGroupItem([state.groups.items.at(u)]))

                                        }
                                    }}
                                    isPeoplePicker={false}
                                    selectedItems={state.groups.selected.length > 0 ? state.groups.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedGroupItem([]))

                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetGroups())
                                        groupsReq.setNextto(0)
                                        dispatch(setIsFilteredGroupsSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getGroups({ body: groupsReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onGroupFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(102)

                                            }
                                        }]}
                                />

                            </Stack>

                            <Field name="typeName" label={<div>
                                {t("clientTypeName") + ' '}
                                <TooltipHost content={t("clientConfigTypeNameDesc")}>
                                    <Icon iconName="Info" aria-label={t("clientTypeName")} />
                                </TooltipHost>
                            </div>} placeholder={t("clientTypeName")} component={InputField} disabled={state.isLoading} maxLength={50} />

                            <Toggle
                                label={<div>
                                    {t("isDefault") + ' '}
                                    <TooltipHost content={t("isDefaultDesc")}>
                                        <Icon iconName="Info" aria-label={t("isDefault")} />
                                    </TooltipHost>
                                </div>}
                                onText={t("isDefaultOn")} offText={t("isDefaultOff")}
                                disabled={state.isLoading}
                                checked={formkikProps.values.isDefault}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isDefault', checked);
                                }
                                }
                            />


                            <Toggle
                                label={t("enableAbililtyToOpenAccount")}
                                onText={t("enabled")} offText={t("disabled")}
                                disabled={state.isLoading}
                                checked={formkikProps.values.canOpenAccount}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('canOpenAccount', checked);
                                }
                                }
                            />

                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("accountLocked") + ' '}
                                    <TooltipHost content={t("authorizedClientDesc")}>
                                        <Icon iconName="Info" aria-label={t("accountLocked")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <Toggle
                                onText={t("enabled")} offText={t("disabled")}
                                disabled={state.isLoading}
                                checked={formkikProps.values.isAccountLockingEnabledByDefault}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isAccountLockingEnabledByDefault', checked);
                                }
                                }
                            />
                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("isIdentityVerificationRequired") + ' '}
                                    <TooltipHost content={t("isIdentityVerificationRequiredDesc")}>
                                        <Icon iconName="Info" aria-label={t("isIdentityVerificationRequired")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <Toggle

                                onText={t("enabled")} offText={t("disabled")}
                                disabled={state.isLoading}
                                checked={formkikProps.values.isIdentityVerificationRequired}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isIdentityVerificationRequired', checked);
                                }
                                }
                            />

                            <Stack.Item grow>
                                <Label disabled={state.isLoading}>{
                                    <div>
                                        {t("isIdentityVerificationDocs") + ' '}
                                        <TooltipHost content={t("isIdentityVerificationDocsDesc")}>
                                            <Icon iconName="Info" aria-label={t("isIdentityVerificationDocs")} />
                                        </TooltipHost>
                                    </div>
                                }</Label>
                                <FieldArray
                                    name="identityVerificationDocuments"
                                >
                                    {arrayHelpers => {
                                        let r = [] as React.ReactNode[];
                                        if (formkikProps.values.identityVerificationDocuments && formkikProps.values.identityVerificationDocuments.length > 0) {
                                            r = formkikProps.values.identityVerificationDocuments.map((o, index) => {
                                                if (o.type == 1) {
                                                    return (<Stack horizontal key={index}>
                                                        {o.label != undefined ? <DynamicInputField name={`identityVerificationDocuments[${index}].label`} placeholder={t("label")} disabled={state.isLoading}
                                                            maxLength={50} /> : null}
                                                        <DynamicInputField name={`identityVerificationDocuments[${index}].value`} placeholder={"جواز سفر | passport"} disabled={state.isLoading}
                                                            maxLength={50} autoFocus={(o as any)?.autoFocus}
                                                        />

                                                        <IconButton disabled={state.isLoading} iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                    </Stack>)
                                                }
                                            }
                                            )
                                        }
                                        if (formkikProps.values.identityVerificationDocuments.length <= 5) {
                                            r.push(< IconButton disabled={state.isLoading} key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.identityVerificationDocuments.length + 1) + "", label: undefined, type: 1, value: "", autoFocus: true })
                                            }} />)
                                        }
                                        return r;
                                    }
                                    }

                                </FieldArray>

                            </Stack.Item>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("add") : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>



                    </Form>
                )}
            </Formik>
        </>
    );

}

